import auth from '@/util/auth';
import validateMultiple from '@/util/validator';
import queryErrors from '@/util/queryErrors';

const ParleyAdmin = {
    install: (Vue, options) => {
        Vue.prototype.$parleyAdmin = {
            auth: auth,
            queryErrors: queryErrors,
            validateMultiple: validateMultiple,
            libraryVersion: '1.0.7'
        };
    }
};

export default ParleyAdmin;
